import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from 'lodash'
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectListItems } from "../../../../../redux/library/selector";
import storePersist from "../../../../../redux/storePersist";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectDbaPartnerAgencyMappingsListItems } from "../../../../../redux/dba-partner-agency-mappings/selector";
import { dbaPartnerAgencyMappings } from "../../../../../redux/dba-partner-agency-mappings/action";

const DSAPAgencyMyRequests = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
    const associatedPartnerItems = useSelector(selectDbaPartnerAgencyMappingsListItems)
    const userProfileData = storePersist?.get("userProfile")?.current;
    const userProfileAccountId = userProfileData?.items[0]?.Message?.AccountDetail?.Id
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
       
          { field: 'InternalDBAName', headerName: 'Internal DBA Name' },
          { field: 'PartnerDBAName', headerName: 'Partner DBA Name' },
          { field: 'IsApprovedByPartnerAgency', headerName: 'Approved by Partner Agency', cellRenderer: 'yesNoRenderer' },
          { field: 'IsApprovedByInternalAgency', headerName: 'Approved by Internal', cellRenderer: 'yesNoRenderer' },
          {
            field: 'ApprovalStatusId',
            headerName: 'Approval Status',
            cellRenderer: 'libraryRendererComponent',
            cellRendererParams: { library: libraryData?.result?.ApprovalStatus },
            sortable: true,
            filter: false,
          },
                ]);
              }
      const fetchAssociatedPartner=()=>{

        dispatch(dbaPartnerAgencyMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings/list`,entity:'dbaPartnerAgencyMappings',jsonData:{
      "Context":{},
          "Records":[{
            IsApprovedByPartnerAgency : false,
            IsApprovedByInternalAgency: true,
            ApprovalStatusId : 10,
            InternalAccountId: userProfileAccountId
          }],
        "Pagination":{
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        }
    
        }}))
       
      } 
      useEffect(() => { 
        fetchAssociatedPartner()
  }, [pageData])
 
  useEffect(() => {
    createColumnDefs()
}, [associatedPartnerItems])
const handleSearch = (data: any) => {
  console.log('Search data', data)
  let searchCriteria = {};
  if (data?.column){
    searchCriteria = [{
      FieldName: data?.column,
      FieldText: data?.column,
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
  } else {
    searchCriteria = [{
      FieldName: "Name",
      FieldText: "Name",
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
  }

  dispatch(dbaPartnerAgencyMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings/list`,entity:'dbaPartnerAgencyMappings',jsonData:{
    "Context":{},
          "Records":[{
            IsApprovedByPartnerAgency : false,
            IsApprovedByInternalAgency: true,
            ApprovalStatusId : 10,
            InternalAccountId: userProfileAccountId
          }],
        "Pagination":{
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches" :searchCriteria
        }

    }}))
}
const filterTypes = [{
  name: 'Text', value: "text"
},
{
  name: 'Number', value: "number"
},
{
  name: 'CheckBox', value: "checkbox"
},
{
  name: 'Date', value: "date"
}
]
const handleReloadData = () => {
  fetchAssociatedPartner()
}
const additionButtons: any = [

  {
    svg:
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
      <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    name: 'Reload',
    callback: () => handleReloadData(),
  },
];

    const handleApprovalStatusClick = async (event: any, dataId: any, reasonId: any) => {
        if (event === 20) {
          dispatch(dbaPartnerAgencyMappings.update({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings`,
            entity: 'dbaPartnerAgencyMappings',
            jsonData: {
                Context:{},
                Records: [
                  {
                    "Id": dataId?.Id,
                      "PartnerDBNPId": dataId?.PartnerDBNPId,
                      "PartnerDBAId":dataId?.PartnerDBAId,
                      "PartnerAccountId":dataId?.PartnerAccountId,
                      "InternalAccountId":dataId?.InternalAccountId,
                      "IsApprovedByPartnerNP": dataId?.IsApprovedByPartnerNP,
                      "IsApprovedByInternalNP": dataId?.IsApprovedByInternalNP,
                      "IsApprovedByPartnerAgency": dataId?.IsApprovedByPartnerAgency,
                      "IsApprovedByInternalAgency": dataId?.IsApprovedByInternalAgency,
                      "ApprovalStatusId": event,
                      "ApprovalCondition": dataId?.ApprovalCondition
                  }
                  ]
            }
          })).then(() => {
            dispatch(dbaPartnerAgencyMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings/list`,entity:'dbaPartnerAgencyMappings',jsonData:{
                "Context":{},
          "Records":[{
            IsApprovedByPartnerAgency : false,
            IsApprovedByInternalAgency: true,
            ApprovalStatusId : 10,
            InternalAccountId: userProfileAccountId
          }],
        "Pagination":{
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        }
                }}))
        })
        } else if (event === 30) {
            dispatch(dbaPartnerAgencyMappings.update({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings`,
                entity: 'dbaPartnerAgencyMappings',
                jsonData: {
                    Context:{},
                    Records: [
                      {
                        Context:{},
                Records: [
                  {
                    "Id": dataId?.Id,
                      "PartnerDBNPId": dataId?.PartnerDBNPId,
                      "PartnerDBAId":dataId?.PartnerDBAId,
                      "PartnerAccountId":dataId?.PartnerAccountId,
                      "InternalAccountId":dataId?.InternalAccountId,
                      "IsApprovedByPartnerNP": dataId?.IsApprovedByPartnerNP,
                      "IsApprovedByInternalNP": dataId?.IsApprovedByInternalNP,
                      "IsApprovedByPartnerAgency": dataId?.IsApprovedByPartnerAgency,
                      "IsApprovedByInternalAgency": dataId?.IsApprovedByInternalAgency,
                      "ApprovalStatusId": event,
                      "ApprovalCondition": dataId?.ApprovalCondition
                  }
                  ]
                      }
                      ]
                }
          })).then(() => {
            dispatch(dbaPartnerAgencyMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings/list`,entity:'dbaPartnerAgencyMappings',jsonData:{
                 "Context":{},
          "Records":[{
            IsApprovedByPartnerAgency : false,
            IsApprovedByInternalAgency: true,
            ApprovalStatusId : 10,
            InternalAccountId: userProfileAccountId
          }],
        "Pagination":{
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        }
            
                }}))
        })
      };
    }
  const handleDelete=(data: any)=>{
    dispatch(dbaPartnerAgencyMappings.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings/delete`,
      entity: 'dbaPartnerAgencyMappings',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(dbaPartnerAgencyMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-partner-agency-mappings/list`,entity:'dbaPartnerAgencyMappings',jsonData:{
      "Context":{},
          "Records":[{
            IsApprovedByPartnerAgency : false,
            IsApprovedByInternalAgency: true,
            ApprovalStatusId : 10,
            InternalAccountId: userProfileAccountId
          }],
        "Pagination":{
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        }
      
  
      }}))
     
  });
  }
	return (
    <>
    {associatedPartnerItems?.isLoading ? 
  <PageLoader /> : 
		<Table columnData={columnDefs} rowData={associatedPartnerItems?.result?.items} setPageData={setPageData} onDelete={handleDelete}
    paginationData={associatedPartnerItems?.result?.pagination} 
    //  onApprovalStatusClick={handleApprovalStatusClick} IsActionButton={true}
     filterTypeLists={filterTypes}  onSearch={handleSearch}
     additionButtons={additionButtons} enableFilter={true}
    headingName="My Requests" />
  }
  </>

	);
};

export default DSAPAgencyMyRequests;


